import React, { Component } from "react";
import classnames from "classnames";

import { formatNumber } from "@formant/core/common/formatNumber";
import { Icon, IconName } from "@formant/ui/component/common/Icon";

import { Chip } from "./Chip";
import * as styles from "./StatsHeader.scss";

export interface IStatsHeaderProps {
    icon: IconName;
    loading?: boolean;
    totalQuantity: number;
    totalLabel: string;
    groups?: IStatHeaderGroup[];
    className?: string;
}

export interface IStatHeaderGroup {
    chipClassName?: string;
    icon?: IconName;
    subtotalQuantity: number;
    subtotalLabel: string;
}

export class StatsHeader extends Component<IStatsHeaderProps> {
    render() {
        const { icon, loading, totalQuantity, totalLabel, groups, className } =
            this.props;
        const groupContents = ((!loading && groups) || []).map(
            (
                {
                    chipClassName,
                    icon: groupIcon,
                    subtotalQuantity,
                    subtotalLabel,
                },
                i,
            ) => (
                <div className={styles.group} key={i}>
                    <Chip className={chipClassName} />
                    {groupIcon && <Icon name={groupIcon} />}
                    <div className={styles["subtotal-label"]}>
                        {subtotalLabel}
                    </div>
                    <div className={styles["subtotal-quantity"]}>
                        {formatNumber(subtotalQuantity)}
                    </div>
                </div>
            ),
        );
        return (
            <div className={classnames(styles["stats-header"], className)}>
                <Icon className="icon" name={icon} />
                <div className={styles["total-quantity"]}>
                    {!loading && formatNumber(totalQuantity)}
                </div>
                <div className={styles["total-label"]}>{totalLabel}</div>
                {groupContents}
            </div>
        );
    }
}
